<template>
  <ul class="news-filter__btns">
    <li
      v-for="filter in filters"
      :key="filter.id"
      class="news-filter__btn"
      :class="{'selected': selected.id == filter.id}"
      @click="selectFilter(filter)"
    >
      <span v-text="filter.title"/>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    filters: {
        type: Array,
        default: () => []
    },
    selected: {
        type: Object,
        default: () => {}
    }
  },
  methods: {
     selectFilter(filter) {
       console.log('F--',filter)
    //   this.getDataPage({
    //     categoryId: 1,
    //     limit: 20,
    //     subCategory:filter.id
    //   });
    //   console.log('FILTER',filter);
       this.$emit('getSubFilter',filter)

      this.selected.id != filter.id
        ? this.$emit('getSelectedFilter', filter)
        : this.$emit('getSelectedFilter', {})
    }
  }
};
</script>